// extracted by mini-css-extract-plugin
export default {"cont":"placeorder_cont__2H5T6","box":"placeorder_box__hodwn","head":"placeorder_head__yNNF7","btn":"placeorder_btn__9YGaF","imag":"placeorder_imag__yanyg"};